import React, { Fragment, useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import AuthServices from "../../api/AuthServices"; // Assuming this fetches Stripe key
import enhancer from "./AddCard.validator";
import { useTranslation } from "react-i18next";
import Input from "../Input/Input";
import Button from "../common/Button/Button";
import { LanguageSelector } from "../LanguageSelector";
import SlotsPageWrapper from "../Slots/Slots.style";
import Logo from "../../assets/images/CHARGELOGO.png";
import { useMedia } from "../../hook/useMedia";
import clsx from "clsx";
import { message } from "antd";
import { Loader } from "../../icons";
import AuthenticationApiSerivce from "../../api/AuthServices";
import { Input as Select } from "reactstrap";

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      fontSize: "18px",
      color: "#333",
      "::placeholder": {
        color: "#999",
        content: "Número de tarjeta",
      },
      backgroundColor: "transparent", // Matches Input field
      border: "1px solid #ccc", // Matches Input field
      padding: "10px", // Matches Input field
      borderRadius: "5px",
    },
    invalid: {
      color: "#ff0033",
    },
  },
  hidePostalCode: true, // Hide the autofill postal code
};

const AddCardForm = ({
  values,
  handleChange,
  handleBlur,
  errors,
  touched,
  submitCount,
  isValid,
  setFieldTouched,
  setFieldValue,
  handleSubmit,
  history,
  setErrors,
  setFieldError,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const { t } = useTranslation();

  const [stateList, setStateList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    AuthenticationApiSerivce.stateList()
      .then((res) => {
        setStateList(res.data);
      })
      .catch((err) => {
        message.error("Failed to fetch state list! Please try again.");
      });
  }, []);

  const handleSubmitCard = async (e) => {
    e.preventDefault();

    handleSubmit();
    if (!stripe || !elements) {
      setFieldError("cardElement", "Stripe is not loaded yet.");
      setLoading(false);
      return;
    }
    setLoading(true);

    const { token, error } = await stripe.createToken(
      elements.getElement(CardElement),
      {
        name: values?.cardHolderName,
        address_line1: values?.address1,
        address_line2: values?.address2,
        address_city: values?.city,
        address_state: values?.state,
        address_zip: values?.zipCode,
      }
    );

    if (error) {
      setFieldError("cardElement", error.message);
    } else if (isValid) {
      AuthServices.addCard({
        payment_method_token: token.id,
        is_default_payment: values?.isDefaultPayment,
      })
        .then((res) => {
          if (res?.status) {
            message.success(
              res?.message || "Payment information is added successfully."
            );
            history.push("/appointment-confirmation");
          } else {
            message.error(res?.message);
          }
        })
        .catch((err) => {
          message.error(err?.message || err?.response);
        });
    }

    setLoading(false);
  };

  const Error = (props) => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <div className={"Glacial-Regular text-danger fs-14 pt-1"}>
          {t(errors[field1])}
        </div>
      );
    } else {
      return <span />;
    }
  };

  return (
    <form onSubmit={handleSubmitCard} style={{ maxWidth: "100%" }}>
      <Input
        lable={t("CARD_HOLDER_NAME")}
        type="text"
        placeholder={t("CARD_HOLDER_NAME")}
        id="cardHolderName"
        autoComplete="cc-name"
        value={values.cardHolderName}
        onChange={handleChange}
        onBlur={handleBlur}
      ></Input>
      <Error field="cardHolderName" />

      {/* Styled Stripe Card Element */}
      <div
        style={{
          borderBottom: "1px solid #ccc",
          paddingTop: "64px",
          paddingBottom: "8px",
          marginBottom: "10px",
          backgroundColor: "white",
          fontSize: "18px",
        }}
      >
        <CardElement
          options={CARD_ELEMENT_OPTIONS}
          onChange={(event) => {
            if (event.error) {
              setFieldError("cardElement", event.error.message); // Capture real-time Stripe errors
            } else {
              setFieldValue("cardElement", event.complete ? "valid" : null); // Mark field valid
              setErrors((prevErrors) => ({
                ...prevErrors,
                cardElement: undefined,
              })); // Clear previous errors when valid
            }
          }}
          onBlur={() => setFieldTouched("cardElement", true)}
        />
      </div>
      <Error field={"cardElement"} />
      <Input
        lable={t("ADDRESS_1")}
        type="text"
        id="address1"
        autoComplete="address-line1"
        placeholder={t("ADDRESS_1")}
        value={values.address1}
        onChange={handleChange}
        onBlur={handleBlur}
      ></Input>
      <Error field="address1" />
      <Input
        lable={t("ADDRESS_2")}
        type="text"
        id="address2"
        autoComplete="address-line2"
        placeholder={t("ADDRESS_2")}
        value={values.address2}
        onChange={handleChange}
        onBlur={handleBlur}
      ></Input>
      <Error field="address2" />
      <Input
        lable={t("CITY")}
        type="text"
        id="city"
        autoComplete="address-level2"
        placeholder={t("CITY")}
        value={values.city}
        onChange={handleChange}
        onBlur={handleBlur}
      ></Input>
      <Error field="city" />

      <div className="flex">
        <div className="fill-width pr-4">
          <div className="mt-14 fill-width">
            <label className="fs-18 Glacial-Regular">{t("STATE")}</label>
            <Select
              type="select"
              name="state"
              id="state"
              autoComplete="address-level1"
              onChange={handleChange}
              value={values.state}
              onBlur={handleBlur}
            >
              <option value="">{t("SELECT_ONE_LABEL")}</option>
              {stateList.map((type, i) => {
                return (
                  <Fragment>
                    <option key={`option${i}`} value={type.name}>
                      {type.name}
                    </option>
                  </Fragment>
                );
              })}
            </Select>
            <Error field="state" />
          </div>
        </div>
        <div className="fill-width pl-4">
          <Input
            lable={t("ZIP_CODE")}
            type="text"
            id="zipCode"
            autoComplete="postal-code"
            placeholder={t("ZIP_CODE")}
            value={values.zipCode}
            onChange={handleChange}
            onBlur={handleBlur}
          ></Input>
          <Error field="zipCode" />
        </div>
      </div>
      <div className="fs-16 Glacial-Regular mtp-2 fill-width">
        <input
          type="checkbox"
          id="isDefaultPayment"
          name="isDefaultPayment"
          style={{ marginRight: 4, marginTop: 2 }}
          className="cursor-pointer"
          checked={values?.isDefaultPayment}
          onChange={(e) => {
            setFieldTouched("isDefaultPayment", true, true);
            setFieldValue("isDefaultPayment", !values?.isDefaultPayment);
          }}
        />
        {t("DEFAULT_PAYMENT_METHOD")}
        <Error field="isDefaultPayment" />
      </div>

      <div className="fill-width flex align-center justify-center pb-6">
        <Button
          text={t("ADD_CARD_BTN")}
          width="164px"
          marginTop="32px"
          type="submit"
          disabled={loading}
          loading={loading}
        />
      </div>
    </form>
  );
};

const AddCard = (props) => {
  const { isTabletOrMobile, isDesktopOrLaptop, isMobile } = useMedia();
  const { t } = useTranslation();

  const [stripePromise, setStripePromise] = useState(null);

  useEffect(() => {
    const fetchStripeKey = async () => {
      AuthServices.getStripePublishKey()
        .then((res) => {
          setStripePromise(loadStripe(res?.data?.publishable_token));
        })
        .catch((err) => {
          message.error("Error fetching Stripe publishable key");
        });
    };

    fetchStripeKey();
  }, []);

  return (
    <SlotsPageWrapper>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          position: "relative",
        }}
      >
        <div className="pos-absolute" style={{ right: 12, top: 4 }}>
          <LanguageSelector />
        </div>
        <div className="flex-100 pt-18">
          <div>
            <img src={Logo} height={"100%"} width="100%" alt={"Husk Logo"} />
          </div>
        </div>
        {!stripePromise ? (
          <div className="flex flex-1 align-items-center justify-center fs-18 light-blue ptb-20">
            <Loader height="72px" width="72px"></Loader>
          </div>
        ) : (
          <div className="d-flex flex-y">
            <div
              className={clsx(
                "Glacial-Bold jumbotrons fs-24 pa-12 text-center",
                !isTabletOrMobile && "fs-34 pt-32 pb-12"
              )}
            >
              {t("Add Credit Card")}
            </div>
            <div className="fill-width flex flex-y align-center">
              <div
                style={{
                  width: isTabletOrMobile ? "100%" : "50%",
                  paddingInline: 12,
                }}
              >
                <div className="fs-12 Glacial-Italic mtp-1 fill-width">
                  {t("PAYMENT_NOTE_1")}{" "}
                  <span
                    className="border-bottom fs-12 Glacial-Regular cursor-pointer"
                    onClick={(e) =>
                      window.open(`${process.env.REACT_APP_PUBLIC_URL}/payment`)
                    }
                  >
                    {" Husk "}
                    {t("PAYMENT_POLICY")}
                  </span>{" "}
                  {t("PAYMENT_NOTE_2")}
                </div>
                <Elements stripe={stripePromise}>
                  <AddCardForm {...props} />
                </Elements>
              </div>
            </div>
          </div>
        )}
      </div>
    </SlotsPageWrapper>
  );
};

export default compose(withRouter, enhancer, connect(null, null))(AddCard);
